import React, { useState } from "react";
import { FaMinus, FaPlus, FaFileMedical, FaShieldAlt, FaLaptopMedical, FaLock, FaKey, FaCloud, FaFingerprint, FaUserShield, FaDatabase, FaClipboardCheck, FaServer, FaBug, FaGlobe, FaUserSecret, FaCode } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcareDataSecurity/DataSecurity.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        title: "End-to-End Encryption (E2EE)",
        description:
          "End-to-end encryption ensures that patient data remains confidential during transmission by encrypting it on the sender’s device and decrypting it only on the recipient’s device. This prevents unauthorized access from third parties, including hackers, internet service providers, and even cloud storage providers. E2EE is particularly critical in telemedicine consultations, remote patient monitoring, and electronic health record (EHR) sharing."
      },
      {
        title: "HIPAA-Compliant Data Security",
        description:
          "HIPAA-compliant security measures ensure that healthcare organizations follow strict guidelines for protecting patient data. This includes encrypting patient records both at rest and in transit, implementing access controls, conducting regular security audits, and enforcing breach notification protocols. Compliance with HIPAA (Health Insurance Portability and Accountability Act) prevents unauthorized disclosure of patient health information (PHI) and minimizes the risk of data breaches."
      },
      {
        title: "Cloud-Based Encryption",
        description:
          "Cloud-based encryption protects sensitive medical data stored in cloud environments by encoding it in a way that only authorized users with the correct decryption keys can access it. This helps healthcare providers and hospitals securely store and back up patient records, medical images, and lab results in the cloud without exposing them to cyber threats. Cloud encryption also supports secure data sharing between hospitals, clinics, and research institutions while preventing unauthorized access."
      },
      {
        title: "Zero Trust Architecture",
        description:
          "Zero Trust Architecture (ZTA) operates under the principle of 'never trust, always verify.' It requires continuous identity verification and strict access controls for every user, device, and application attempting to access healthcare systems. This model prevents unauthorized access, mitigates insider threats, and minimizes the attack surface by restricting access to only necessary resources. Zero Trust is essential for protecting healthcare IT networks from ransomware attacks, phishing attempts, and data breaches."
      },
      {
        title: "Tokenization & Data Masking",
        description:
          "Tokenization replaces sensitive patient data, such as Social Security numbers, medical record IDs, and billing information, with unique identifiers (tokens) that have no exploitable value. This ensures that even if the data is intercepted, it remains meaningless to attackers. Data masking further enhances privacy by anonymizing data for research purposes, allowing healthcare organizations to use patient data for analytics without exposing identifiable information."
      },
      {
        title: "Blockchain Encryption for Health Records",
        description:
          "Blockchain technology provides a decentralized and tamper-proof method of storing and sharing electronic health records (EHRs). Every update or access to a medical record is recorded as a cryptographically secure transaction, ensuring transparency, integrity, and security. Patients can control access to their medical data, granting permissions to healthcare providers as needed. Blockchain encryption prevents data manipulation, unauthorized alterations, and cyberattacks on medical records."
      }
    ];
const features = [
    { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "AES-256 encryption for medical records and patient data." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Advanced cybersecurity measures to protect against data breaches." },
    { icon: <FaKey className="text-[#2a627a] text-lg" />, text: "Secure key management systems for encryption and decryption processes." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "EHR encryption to safeguard patient information from cyber threats." },
    { icon: <FaCloud className="text-[#2a627a] text-lg" />, text: "Encrypted cloud storage for safe data transmission and backup." },
    { icon: <FaFingerprint className="text-[#2a627a] text-lg" />, text: "Biometric authentication for secure access to medical data." }
];

const benefits = [
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Prevents unauthorized access to sensitive patient data." },
    { icon: <FaDatabase className="text-[#2a627a] text-lg" />, text: "Secures EHRs and medical databases from cyber threats." },
    { icon: <FaServer className="text-[#2a627a] text-lg" />, text: "Ensures compliance with HIPAA, GDPR, and other healthcare regulations." },
    { icon: <FaGlobe className="text-[#2a627a] text-lg" />, text: "Protects patient data during global telehealth consultations." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Maintains data integrity and prevents unauthorized modifications." },
    { icon: <FaBug className="text-[#2a627a] text-lg" />, text: "Reduces vulnerabilities to hacking, ransomware, and phishing attacks." }
]
const cmsFeatures = [
    { icon: <FaUserSecret className="text-[#2a627a] text-lg" />, text: "Cybersecurity Analyst – Monitors threats and secures healthcare systems." },
    { icon: <FaCode className="text-[#2a627a] text-lg" />, text: "Encryption Engineer – Develops and maintains encryption protocols." },
    { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "Health IT Security Consultant – Ensures compliance with encryption standards." },
    { icon: <FaFingerprint className="text-[#2a627a] text-lg" />, text: "Biometric Security Specialist – Implements fingerprint and facial recognition for secure access." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Data Protection Officer – Oversees healthcare data security policies." },
    { icon: <FaCloud className="text-[#2a627a] text-lg" />, text: "Cloud Security Architect – Designs secure cloud storage solutions for medical data." }
];

const Dataencryption = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Data Encryption in Healthcare - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Data encryption in healthcare ensures the confidentiality, integrity, and security of patient information by converting sensitive data into an unreadable format, accessible only with authorized decryption keys."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Data Encryption?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Data encryption is the process of transforming sensitive information into unreadable code to prevent unauthorized access. In healthcare, encryption is essential for protecting patient records, medical transactions, and confidential communications from cyber threats and data breaches.

                            At HIKEHEALTH GS, we implement advanced encryption technologies to ensure end-to-end security for electronic health records (EHR), telemedicine platforms, and healthcare IT infrastructure.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Data Encryption
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default Dataencryption;
